import { render, staticRenderFns } from "./EditSupplierDialog.vue?vue&type=template&id=2e773084&lang=pug&"
import script from "./EditSupplierDialog.vue?vue&type=script&lang=ts&"
export * from "./EditSupplierDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditSupplierDialog.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports